import { TextScramble } from '@/components/motion-primitives/text-scramble';
import { ArrowLeft } from 'lucide-react';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LiquidGlassEffect from './LiquidGlassEffect';

export default function ProjectNav() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleBack = () => {
        if (location.key !== 'default') {
            navigate(-1); // Go back if there's a previous page
        } else {
            navigate('/'); // Otherwise go to home
        }
    };

    return (
        <div id="appbar-glass" className='shadow-2xl z-[9] fixed top-4 left-1/2 -translate-x-1/2 px-2 py-1 text-center space-x-2 rounded-full'>
            <div className='flex items-center justify-between w-[350px]'>
                <div className='flex items-center gap-x-2'>
                    <img src='/unaascii-sm.webp' className='h-8 rounded-full cursor-pointer' onClick={() => navigate('/')} />
                    {/* <h1 className='font-semibold w-fit opacity-40 dark:opacity-90 px-2'>Selected Projects</h1> */}
                    <TextScramble className='font-mono text-sm uppercase'>
                        Selected Project
                    </TextScramble>
                </div>
                <button
                    className='rounded-full p-2 font-semibold flex gap-x-2 items-center cursor-pointer'
                    onClick={handleBack}
                >
                    <ArrowLeft className='h-5' /> Back
                </button>
            </div>
            <LiquidGlassEffect targetSelector="#appbar-glass" width={200} height={64} />
        </div>
    );
}
